import React from "react";
import {Typography} from "@mui/material";
import './HorizontalLegendComponent.css';
import {Build as BuildIcon, Check as CheckIcon, Remove as RemoveIcon} from "@mui/icons-material";

export default function HorizontalLegendComponent() {
    const legendItems = [
        {
            label: 'תהליך שעוד לא התחיל',
            icon: <RemoveIcon/>,
            bgColor: '#AFBDD3',     // grey 400
            iconColor: '#FFFFFF',   // grey 600
        },
        {
            label: 'תהליך שהסתיים',
            icon: <CheckIcon/>,
            bgColor: '#77DBA4',     // green 500
            iconColor: '#ffffff',
        },
        {
            label: 'תהליך בביצוע',
            icon: <BuildIcon/>,
            bgColor: '#1293FE',     // blue 500
            iconColor: '#ffffff',
        },
        {
            label: 'עיכוב של עד שנה',
            bgColor: '#FFBD06',     // amber 500
            iconColor: '#212121',   // grey 900
        },
        {
            label: 'עיכוב של מעל שנה',
            bgColor: '#ff5722',     // deepOrange 500
            iconColor: '#ffffff',
        }
    ];

    return (
        <div className="horizontal-legend-container">
            <Typography
                className="horizontal-legend-title"
                component="h3"
                id="legend-title">
                מקרא הצבעים:
            </Typography>
            <ul
                className="horizontal-legend-list"
                aria-labelledby="legend-title">
                {legendItems.map((item, index) => (
                    <li
                        key={index}
                        className="horizontal-legend-item"
                        style={{marginLeft: index === 2 ? 30 : 0}}>
                        <div
                            className="horizontal-legend-color"
                            style={{backgroundColor: item.bgColor}}>
                            {item.icon &&
                                React.cloneElement(item.icon, {
                                    sx: {fontSize: "14px", color: item.iconColor},
                                    "aria-hidden": true, // Icons are decorative
                                })}
                        </div>
                        <Typography component="span">{item.label}</Typography>
                    </li>
                ))}
            </ul>
        </div>

    );
}